import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=d1b2475c&scoped=true&"
import script from "./Infos.vue?vue&type=script&lang=js&"
export * from "./Infos.vue?vue&type=script&lang=js&"
import style0 from "./Infos.vue?vue&type=style&index=0&id=d1b2475c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b2475c",
  null
  
)

export default component.exports